import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=6501ccd4&scoped=true&"
import script from "./centerBottom.vue?vue&type=script&lang=js&"
export * from "./centerBottom.vue?vue&type=script&lang=js&"
import style0 from "./centerBottom.vue?vue&type=style&index=0&id=6501ccd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6501ccd4",
  null
  
)

export default component.exports